/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const createCustomFieldDataLocationSchema = z.enum(['invoice'])

export type CreateCustomFieldDataLocationSchema = z.infer<typeof createCustomFieldDataLocationSchema>
